module.exports = __webpack_public_path__ + "img/product_placeholder.6d9cbdf.svg";